import React from 'react';
import { Link } from 'react-router-dom';

const NavOne = () => {
    return(
            <>
                <div>
                    {/*Header-Upper*/}
                    <div className="header-upper">
                        <div className="default-container">
                            <div className="clearfix">
                                <div className="pull-left logo-box">
                                    <div className="logo">
                                    <Link to="/"><img src="images/logo.png" alt="" title /></Link>
                                    </div>
                                </div>
                                <div className="nav-outer clearfix">
                                    {/* Main Menu */}
                                    <nav className="main-menu navbar-expand-md">
                                    <div className="navbar-header">
                                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                        <i className="icon-bar" />
                                        <i className="icon-bar" />
                                        <i className="icon-bar" />
                                        </button>
                                    </div>
                                    <div className="navbar-collapse collapse clearfix" id="navbarSupportedContent">
                                        <ul className="navigation clearfix">
                                        <li className="current dropdown"><Link to="/#">Home</Link>
                                            <ul>
                                            <li><Link to="/">Home 01</Link></li>
                                            <li><Link to="/home-2">Home 02</Link></li>
                                            <li><Link to="/home-3">Home 03</Link></li>
                                            <li><Link to="/home-4">Home 04</Link></li>
                                            </ul>
                                        </li>
                                        <li className="dropdown"><Link to="/#">Pages</Link>
                                            <ul>
                                            <li><Link to="/about-us">About Us</Link></li>
                                            <li><Link to="/team">Team</Link></li>
                                            <li><Link to="/404">404</Link></li>
                                            </ul>
                                        </li>
                                        <li className="dropdown"><Link to="/#">Projects</Link>
                                            <ul>
                                            <li><Link to="/projects-fullwidth-three-column">Projects 01</Link></li>
                                            <li><Link to="/projects-fullwidth-two-column">Projects 02</Link></li>
                                            <li><Link to="/single-project">Project Details</Link></li>
                                            </ul>
                                        </li>
                                        <li><Link to="/price">Price</Link></li>
                                        <li className="dropdown"><Link to="/#">Blog</Link>
                                            <ul>
                                            <li><Link to="/blog-posts-fullwidth">Blog 01</Link></li>
                                            <li><Link to="/blog-posts-fullwidth-two-column">Blog 02</Link></li>
                                            <li><Link to="/blog-posts-left-sidebar">Blog 03</Link></li>
                                            <li><Link to="/blog-posts-right-sidebar">Blog 04</Link></li>
                                            <li><Link to="/single-post-fullwidth">Blog Details 01</Link></li>
                                            <li><Link to="/single-post-left-sidebar">Blog Details 02</Link></li>
                                            <li><Link to="/single-post-right-sidebar">Blog Details 03</Link></li>
                                            </ul>
                                        </li>
                                        <li><Link to="/contact-us">Contact us</Link></li>
                                        </ul>
                                    </div>
                                    </nav>
                                    {/*Button Box*/}
                                    <div className="button-box">
                                    <Link to="/contact" className="ploting-btn btn-style-one">Ask For Quote</Link>
                                    </div>
                                    {/*Search Box Outer*/}
                                    <div className="menu-search-box">
                                        <div className="dropdown">
                                            <button className="menu-sb-btn dropdown-toggle" type="button" id="dropdownMenu3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i className="fa fa-search plot-sty" /></button>
                                            <ul className="dropdown-menu pull-right search-panel" aria-labelledby="dropdownMenu3">
                                                <li className="panel-outer">
                                                    <div className="form-container">
                                                        <form method="post" action="#">
                                                            <div className="form-group">
                                                                <input type="search" name="field-name" placeholder="Search Here" required />
                                                                <button type="submit" className="search-btn"><i className="fa fa-search" /></button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*End Header Upper*/}
                    {/*Sticky Header*/}
                    <div className="sticky-header">
                        <div className="default-container clearfix">
                            {/*Logo*/}
                            <div className="logo pull-left">
                            <Link to="/" className="img-responsive"><img src="images/logo-small.png" alt="" title /></Link>
                            </div>
                            {/*Right Col*/}
                            <div className="right-col pull-right">
                            {/* Main Menu */}
                            <nav className="main-menu navbar-expand-md">
                                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent1" aria-controls="navbarSupportedContent1" aria-expanded="false" aria-label="Toggle navigation">
                                <i className="icon-bar" />
                                <i className="icon-bar" />
                                <i className="icon-bar" />
                                </button>
                                <div className="navbar-collapse collapse clearfix" id="navbarSupportedContent1">
                                <ul className="navigation clearfix">
                                    <li className="current dropdown"><Link to="/#">Home</Link>
                                    <ul>
                                        <li><Link to="/">Home 01</Link></li>
                                        <li><Link to="/home-2">Home 02</Link></li>
                                        <li><Link to="/home-3">Home 03</Link></li>
                                        <li><Link to="/home-4">Home 04</Link></li>
                                    </ul>
                                    </li>
                                    <li className="dropdown"><Link to="/#">Pages</Link>
                                    <ul>
                                        <li><Link to="/about-us">About Us</Link></li>
                                        <li><Link to="/team">Team</Link></li>
                                        <li><Link to="/404">404</Link></li>
                                    </ul>
                                    </li>
                                    <li className="dropdown"><Link to="/#">Projects</Link>
                                    <ul>
                                        <li><Link to="/projects-fullwidth-three-column">Projects 01</Link></li>
                                        <li><Link to="/projects-fullwidth-two-column">Projects 02</Link></li>
                                        <li><Link to="/single-project">Project Details</Link></li>
                                    </ul>
                                    </li>
                                    <li><Link to="/price">Price</Link></li>
                                    <li className="dropdown"><Link to="/#">Blog</Link>
                                    <ul>
                                        <li><Link to="/blog-posts-fullwidth">Blog 01</Link></li>
                                        <li><Link to="/blog-posts-fullwidth-two-column">Blog 02</Link></li>
                                        <li><Link to="/blog-posts-left-sidebar">Blog 03</Link></li>
                                        <li><Link to="/blog-posts-right-sidebar">Blog 04</Link></li>
                                        <li><Link to="/single-post-fullwidth">Blog Details 01</Link></li>
                                        <li><Link to="/single-post-left-sidebar">Blog Details 02</Link></li>
                                        <li><Link to="/single-post-right-sidebar">Blog Details 03</Link></li>
                                    </ul>
                                    </li>
                                    <li><Link to="/contact-us">Contact us</Link></li>
                                </ul>
                                </div>
                            </nav>
                            {/* Main Menu End*/}
                            </div>
                        </div>
                    </div>
                    {/*End Sticky Header*/}
                </div>
        </>
    )
}

export default NavOne;